import React from 'react';
import { useLoading } from '@context/LoadingContext';
import { LoadingFallback } from './Loader';

export const GlobalLoader: React.FC = () => {
  const { isLoading } = useLoading();

  if (!isLoading) {
    return null;
  }

  return <LoadingFallback />;
};
